import { Reveal } from "@/components/Reveal";
import { MEDIA } from "@/lib/media";

export default function IndigenousKnowledge() {
  return (
    <section className="bg-sandstone py-24 md:py-40" data-testid="indigenous-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <Reveal className="lg:col-span-5 lg:order-2">
            <div className="overflow-hidden">
              <img src={MEDIA.plantingWoman} alt="Experienced practitioners on Country" loading="lazy" className="w-full h-[420px] md:h-[560px] object-cover" />
            </div>
          </Reveal>

          <div className="lg:col-span-7 lg:order-1">
            <Reveal>
              <p className="overline text-copper mb-6">Experienced practitioners</p>
              <blockquote className="font-serif text-3xl md:text-4xl lg:text-5xl font-light leading-[1.15] text-rainforest">
                Learn from experienced practitioners.
              </blockquote>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-10 text-charcoal/75 text-lg font-light leading-relaxed max-w-xl">
                Our programs are delivered by people with practical experience in native seed
                collection, seed banking, propagation, ecological restoration, nursery production and
                landscape management. Rather than relying on theory alone, participants learn from
                professionals working across Australia's native seed and restoration sector.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
